// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"291":"b86befcc","605":"cbbf5dd2"}[chunkId] + ".chunk.js";
};